import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import {
  FilterStateKeys,
  INew_TableAction,
  INew_TableFilter,
  INew_TableFIlterNotifier
} from '@lla-platform/core/core-data-access'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-overview-filters-item',
  templateUrl: './overview-filters-item.component.html',
  styleUrls: ['./overview-filters-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OverviewFiltersItemComponent {
  @Input() advancedFilterKey: FilterStateKeys
  @Input() filter: INew_TableFilter
  @Input() overviewKey: string | undefined
  @Input() tableActions: INew_TableAction

  @Output() filterChanged = new EventEmitter<INew_TableFIlterNotifier>()
  @Output() clearAllFilters = new EventEmitter()
}
